import { gql } from '@apollo/client';

export const GET_DIMENSIONS = gql`
    query DQgetDimensions{
      DQgetDimensions{
            dimensionId
            dimensionName
          }
    }
`;

export const GET_COLUMNS = gql`
    query DQgetColumns($fileName: String!, $columnId: Int, $columnName: String) {
      DQgetColumns(fileName : $fileName, columnId: $columnId, columnName: $columnName) {
        columnId
        columnName
        }
    }
`;

export const GET_FILTER_TYPES = gql`
    query DQgetFilterTypes{
      DQgetFilterTypes {
            filterTypeId
            filterType
          }
    }
`;

export const GET_DQ_RULES = gql`
query DQgetRules($projectId : Int!){
  DQgetRules(projectId : $projectId){
    ruleId
    ruleName
    ruleDescription
    filterExpression
    filterTypeId
    dimensionId
    editable
    }
  }
`;

export const GET_QUALITY_DASHBOARD = gql`
    query DQgetSummary($projectId: Int, $fileName: String) {
        DQgetSummary(projectId : $projectId, fileName: $fileName) {
            overallDQScore
            totalFailedRows
            totalRowsProcessed
            dimScore {
                title
                value
            }
            ruleDetails {
                ruleId
                columnName
                rowsProcessed
                rowsPassed
                score
            }
        }
    }
`;

export const GET_ASSIGNED_RULES = gql`
    query DQgetAssignedRules($fileName: String) {
      DQgetAssignedRules(fileName : $fileName) {
        columnId
        columnName
        ruleIds
        ruleArgs{
          ruleId
          operator
          val1
          val2
          cond
        }
        }
    }
`;

export const GET_DIMENSIONS_DETAILS = gql`
    query DQgetDimensionDetails($fileName: String!, $dimensionIds: [Int]!, $columnIds: [Int]) {
      DQgetDimensionDetails(fileName : $fileName, dimensionIds: $dimensionIds, columnIds: $columnIds) {
          dimensionId
          data {
            title
            value
          }
        }
    }
`;

export const GET_DQ_ROW_DETAILS = gql`
    query DQgetRowDetails($fileName: String,$dimensionId: Int, $columnName: String) {
      DQgetRowDetails(fileName : $fileName, dimensionId: $dimensionId, columnName: $columnName) {
        rowId
        value
        ruleId
      }
    }
`;

export const TEST_REGEX = gql`
query DQtestRegex($regex:String,$inputs:[String]) {
	DQtestRegex(regex:$regex,inputs:$inputs)
}`;
